import { useEffect } from "react";

/** Sets document title + meta description + canonical per page. */
const Seo = ({
  title,
  description,
  path,
}: {
  title: string;
  description?: string;
  path: string;
}) => {
  useEffect(() => {
    document.title = title;
    if (description) {
      let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.content = description;
    }
    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `https://hxp.org${path}`;
  }, [title, description, path]);
  return null;
};

export default Seo;
